import PageHeader from "../components/PageHeader";
import HireWebDeveloperContent from "../components/HireWebDevelopers-Content";

const HireWebDevelopers = () => {
    return (
        <>
            <PageHeader pagetitle="Web Developer" breadcrumbMenu="Home" breadcrumbMenuActive="Web Developer" image="/images/backend-developer.jpg" />
            <HireWebDeveloperContent />
        </>
    )
}

export default HireWebDevelopers;